export const CUSTOM_STYLES_ID = 'website-custom-styles';
export const SITEGEN_WIDGET_CN = 'sitegen-widget';
